const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Convert a customer-assets image URL into a compressed proxy URL.
 * Returns original URL for non-customer-assets images.
 */
export function proxyImg(url, width = 400, quality = 70) {
  if (!url || !url.includes("customer-assets.emergentagent.com")) return url;
  return `${API}/api/img?url=${encodeURIComponent(url)}&w=${width}&q=${quality}`;
}
